/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Grid, Box, Button, Container, Paper, Link } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import T from 'i18n-react';
import {
  getLocale,
  // countryListWithoutVIUS as countryList,
  // businessType
} from 'util/icwUtility';
// import Select from 'react-select';
// import { useSnackbar } from 'notistack';
// import { TextField } from 'icw-components/InputFields';
// import AddIcon from '@material-ui/icons/Add';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';
import Header from '../../Layout/Header/beforeLogin/Header';

import CompanyDetails from './CompanyDetails';
import ProductDetails from './ProductDetails';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#F4F6FA !import',
    backgroundColor: '#F4F6FA !import',
  },
  container: {
    padding: '40px',
    maxWidth: '850px',
    height: '100%',
    background: '#F4F6FA !import',
    backgroundColor: '#F4F6FA !import',
  },
  topBanner: {
    maxWidth: '100%',
    '@media (max-width:767px)': {
      display: 'none',
    },
  },
  topBannerMobile: {
    maxWidth: '100%',
    '@media (min-width:768px)': {
      display: 'none',
    },
  },
  paper: {
    padding: '10px 40px',
  },
  successMessage: {
    padding: '200px 24px',
  },
  saveBtn: {
    color: '#fff',
    backgroundColor: '#005EFF',
    borderRadius: '2px',
    '&:hover': {
      backgroundColor: '#005EFF',
    },
  },
  stepper: {
    padding: '5px 0px 0px',
  },
  stepIcon: {
    fontSize: '28px',
    '& text': {
      fontWeight: 'bold',
    },
    '&.MuiStepIcon-active': {
      color: '#005EFF',
    },
    '&.MuiStepIcon-completed': {
      color: '#005EFF',
    },
  },
}));

const companyValidationSchema = {
  companyName: Yup.string().required(T.translate('iSource.error.companyName')),
  country: Yup.string().required(T.translate('iSource.error.country')),
  businessType: Yup.object().required(T.translate('iSource.error.businessType')),
  contactPerson: Yup.string().required(T.translate('iSource.error.contactPerson')),
  email: Yup.string()
    .email(T.translate('iSource.error.emailFormat'))
    .required(T.translate('iSource.error.email')),
  countryCode: Yup.string().required(T.translate('iSource.error.countryCode')),
  phone: Yup.string().required(T.translate('iSource.error.phoneNumber')),
  productCategories: Yup.array().required(T.translate('iSource.error.productCategories')),
  productName: Yup.string().required(T.translate('iSource.error.productName')),
  productProductCategories: Yup.array().required(T.translate('iSource.error.productCategories')),
  productDescription: Yup.string().required(T.translate('iSource.error.productDescription')),

  termsAndConds: Yup.boolean().required(T.translate('iSource.error.checkbox')),
  acceptRefer: Yup.boolean().required(T.translate('iSource.error.checkbox')),
  validInformation: Yup.boolean().required(T.translate('iSource.error.checkbox')),
};

const StepperConnector = withStyles({
  alternativeLabel: {
    top: '14px',
    left: 'calc(-50% + 14px)',
    right: 'calc(50% + 14px)',
  },
})(StepConnector);

const SupplierForm = ({
  isUserLogin,
  onFormInit,
  onSubmit,
  iSourceStatus,
  onProductCategoriesFetch,
  productCategories,
  ...otherProps
}) => {
  const locale = getLocale().replace('-', '');
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const steps = ['Step-1', 'Step-2'];

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const [readyToSubmit, setReadyToSubmit] = useState(false);
  const [brFiles, setBRFiles] = useState([]);
  const [exportLicenseFiles, setExportLicenseFiles] = useState([]);
  const [videos, setVideos] = useState([]);
  const [productSpecFiles, setProductSpecFiles] = useState([]);
  const [productPhotos, setProductPhotos] = useState([]);
  const [productDocuments, setProductDocuments] = useState([]);
  // const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const validationSchema = Yup.object({
    ...companyValidationSchema,
  });

  const formik = useFormik({
    initialValues: {
      companyName: '',
      country: '',
      businessType: '',
      phone: '',
      contactPerson: '',
      email: '',
      productCategories: [],
      companyWebsite: '',
      companyAddress: '',
      majorProducts: '',
      countryCode: '',
      productName: '',
      productProductCategories: [],
      productDescription: '',
      unitPrice: '',
      MOQ: '',
      productSpecification: '',
      paymentTerm: {},
      tradeTerm: {},
      termsAndConds: false,
      acceptRefer: false,
      validInformation: false,
    },
    validationSchema,

    onSubmit: () => {
      if (iSourceStatus === 'fail') {
        setReadyToSubmit(false);
      }
      setReadyToSubmit(true);
    },
  });

  const handleSelectChange = (values, key) => {
    let tempArr = [];
    if (key in ['productCategories', 'productProductCategories']) {
      if (values.length) {
        values.map((value) => tempArr.push(value));
      } else {
        tempArr.push(values);
      }
    } else {
      tempArr = values;
    }
    formik.setFieldValue(key, tempArr, true);
  };

  const getTopBanner = () => {
    return `https://icw-data.oss-cn-hongkong.aliyuncs.com/iSource/form/supplier-form-${locale}.png`;
  };

  const getTopBannerMobile = () => {
    return `https://icw-data.oss-cn-hongkong.aliyuncs.com/iSource/form/supplier-form-${locale}-mobile.png`;
  };

  const getPageTitle = (step) => {
    if (step === 0) {
      return T.translate('iSource.supplierForm.companyDetails.getExpose');
    }

    return T.translate('iSource.supplierForm.productDetails.post1stProduct');
  };

  const getStepContent = (step) => {
    if (step === 0) {
      return (
        <CompanyDetails
          formik={formik}
          productCategories={productCategories}
          brFiles={brFiles}
          exportLicenseFiles={exportLicenseFiles}
          videos={videos}
          setBRFiles={setBRFiles}
          setExportLicenseFiles={setExportLicenseFiles}
          setVideos={setVideos}
          handleSelectChange={handleSelectChange}
        />
      );
    }

    return (
      <ProductDetails
        formik={formik}
        productCategories={productCategories}
        productSpecFiles={productSpecFiles}
        productPhotos={productPhotos}
        productDocuments={productDocuments}
        setProductSpecFiles={setProductSpecFiles}
        setProductPhotos={setProductPhotos}
        setProductDocuments={setProductDocuments}
        handleSelectChange={handleSelectChange}
      />
    );
  };

  const getStepBtn = (step) => {
    if (step === 0) {
      return (
        <>
          <div />
          <Button
            classes={{ root: classes.saveBtn }}
            variant='contained'
            color='primary'
            onClick={() => {
              handleNext();
            }}>
            {T.translate('general.next')}
          </Button>
        </>
      );
    }

    return (
      <>
        <Button
          classes={{ root: classes.backBtn }}
          variant='outlined'
          color='primary'
          onClick={() => {
            handleBack();
          }}>
          {T.translate('general.back')}
        </Button>
        <Button
          classes={{ root: classes.saveBtn }}
          variant='contained'
          color='primary'
          onClick={(values, actions) => {
            formik.handleSubmit(values, actions);
          }}
          disabled={iSourceStatus === 'editing'}>
          {T.translate('general.submit')}
        </Button>
      </>
    );
  };

  useEffect(() => {
    onFormInit();
    onProductCategoriesFetch();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (iSourceStatus === 'fail') {
      setReadyToSubmit(false);
    }

    // eslint-disable-next-line
  }, [iSourceStatus]);

  useEffect(() => {
    if (readyToSubmit) {
      const formData = {
        ...formik.values,
        country: formik.values.country.value,
        paymentTerm: formik.values.paymentTerm.value,
        tradeTerm: formik.values.tradeTerm.value,
        businessType: formik.values.businessType.value,
      };
      const filesDz = {
        brFiles,
        exportLicenseFiles,
        videos,
        productSpecFiles,
        productPhotos,
        productDocuments,
        path: `/iSource/supplier`,
      };
      const checkList = ['termsAndConds', 'acceptRefer', 'validInformation'];
      const isChecked =
        checkList.filter((item) => {
          if (!formData[item]) {
            formik.errors[item] = T.translate('iSource.error.checkbox');
          } else {
            delete formik.errors[item];
          }
          return !formData[item];
        }).length === 0;
      if (!brFiles.length) {
        formik.setFieldError(
          'companyRegistration',
          T.translate('iSource.error.companyRegistration')
        );
      }
      if (isChecked && brFiles.length) {
        onSubmit(filesDz, formData);
      } else {
        setReadyToSubmit(false);
      }
    }

    // eslint-disable-next-line
  }, [readyToSubmit]);

  return (
    <div className={classes.root}>
      <Header {...otherProps} />
      <Box bgcolor='#F4F6FA' height={isUserLogin ? '100vh' : '100%'}>
        <Container classes={{ maxWidthMd: classes.container }} component='div' maxWidth='md'>
          {iSourceStatus !== 'success' && (
            <Box textAlign='center' mb='45px'>
              <img src={getTopBanner()} className={classes.topBanner} alt='' />
              <img src={getTopBannerMobile()} className={classes.topBannerMobile} alt='' />
            </Box>
          )}
          {iSourceStatus !== 'success' ? (
            <Paper classes={{ root: classes.paper }}>
              <Box py={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={2} />
                  <Grid item xs={12} sm={8}>
                    <Box
                      fontSize='28px'
                      fontWeight='bold'
                      color='#232B3A'
                      justifyContent='center'
                      alignItems='center'
                      lineHeight='normal'
                      textAlign='center'>
                      {getPageTitle(activeStep)}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Stepper
                      alternativeLabel
                      activeStep={activeStep}
                      connector={<StepperConnector />}
                      className={classes.stepper}>
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel
                            StepIconProps={{
                              classes: { root: classes.stepIcon },
                            }}
                          />
                        </Step>
                      ))}
                    </Stepper>
                  </Grid>
                </Grid>
              </Box>

              {getStepContent(activeStep)}
              <Box display='flex' justifyContent='space-between' my={4}>
                {getStepBtn(activeStep)}
              </Box>
            </Paper>
          ) : (
            <Paper classes={{ root: classes.successMessage }}>
              <Box color='#232B3A' fontSize='28px' textAlign='center' fontWeight='bold' mb={4}>
                {T.translate('iSource.buyerForm.selectedPlan.message1')}
              </Box>
              <Box color='#3A4861' fontSize='18px' textAlign='center' mb={5}>
                {T.translate('iSource.buyerForm.selectedPlan.message2')}
              </Box>
              <Link href='/'>
                <Box color='#005EFF' fontSize='14px' fontWeight='500' textAlign='center'>
                  {T.translate('iSource.buyerForm.back')}
                </Box>
              </Link>
            </Paper>
          )}
        </Container>
      </Box>
    </div>
  );
};

SupplierForm.propTypes = {
  classes: PropTypes.object,
  isUserLogin: PropTypes.bool.isRequired,
  onFormInit: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default SupplierForm;
